/**
 * @desc 导入补充附件
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.Response;
export function request(
  params: API.rms.expenseReimbursement.importReplenishFile.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/expenseReimbursement/importReplenishFile`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
